const SEGMENTS = {
    SELLER: 'dealers',
};

const VERTICALS = {
    FURNITURE: 'furniture',
    ART: 'art',
    JEWELRY: 'jewelry',
    FASHION: 'fashion',
};

export const ROUTING_SEGMENT_MOBILE = 'mobile';
export const ROUTING_SEGMENT_RESPONSIVE = 'resp';

export { SEGMENTS, VERTICALS };
